<template>
	<div class="m-page-header">
		<img
			class="return"
			src="@/assets/images/m_return.png"
			alt=""
			@click="handleClick"
		/>
		<p class="p-center">{{ title }}</p>
	</div>
</template>

<script setup>
const props = defineProps({
	title: {
		type: String,
		default: "",
	},
	backFunc: {
		type: Function,
		default: null,
	},
});

const router = useRouter(); // Nuxt's useRouter

const handleClick = () => {
	if (props.backFunc) {
		props.backFunc();
	} else {
		router.go(-1); // Keep using router.go() as it's still valid in Nuxt
	}
};
</script>

<style lang="scss" scoped>
.m-page-header {
	position: relative;
	height: 100px;
	background: #ffffff;
	.p-center {
		text-align: center;
		font-size: 36px;
		line-height: 100px;
		color: #333333;
		font-weight: bold;
	}
	.return {
		width: 48px;
		height: 48px;
		position: absolute;
		top: 50%;
		left: 12px;
		transform: translateY(-50%);
	}
}
</style>
